// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2wrt_","label":"Category_label__1STHy","content":"Category_content__22-rO","header":"Category_header__Gzexx","location":"Category_location__3KEzz"};